/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAdd from '../../../../../../Icon/IconAdd';
import IconAddBox from '../../../../../../Icon/IconAddBox';
import IconAddCircle from '../../../../../../Icon/IconAddCircle';
import IconAddCircleOutline from '../../../../../../Icon/IconAddCircleOutline';
import IconArchive from '../../../../../../Icon/IconArchive';
import IconBackspace from '../../../../../../Icon/IconBackspace';
import IconBlock from '../../../../../../Icon/IconBlock';
import IconClear from '../../../../../../Icon/IconClear';
import IconContentCopy from '../../../../../../Icon/IconContentCopy';
import IconContentCut from '../../../../../../Icon/IconContentCut';
import IconContentPaste from '../../../../../../Icon/IconContentPaste';
import IconCreate from '../../../../../../Icon/IconCreate';
import IconDeleteSweep from '../../../../../../Icon/IconDeleteSweep';
import IconDrafts from '../../../../../../Icon/IconDrafts';
import IconFilterList from '../../../../../../Icon/IconFilterList';
import IconFlag from '../../../../../../Icon/IconFlag';
import IconFontDownload from '../../../../../../Icon/IconFontDownload';
import IconForward from '../../../../../../Icon/IconForward';
import IconGesture from '../../../../../../Icon/IconGesture';
import IconInbox from '../../../../../../Icon/IconInbox';
import IconLink from '../../../../../../Icon/IconLink';
import IconLowPriority from '../../../../../../Icon/IconLowPriority';
import IconMail from '../../../../../../Icon/IconMail';
import IconMarkunread from '../../../../../../Icon/IconMarkunread';
import IconMoveToInbox from '../../../../../../Icon/IconMoveToInbox';
import IconNextWeek from '../../../../../../Icon/IconNextWeek';
import IconRedo from '../../../../../../Icon/IconRedo';
import IconRemove from '../../../../../../Icon/IconRemove';
import IconRemoveCircle from '../../../../../../Icon/IconRemoveCircle';
import IconRemoveCircleOutline from '../../../../../../Icon/IconRemoveCircleOutline';
import IconReply from '../../../../../../Icon/IconReply';
import IconReplyAll from '../../../../../../Icon/IconReplyAll';
import IconReport from '../../../../../../Icon/IconReport';
import IconSave from '../../../../../../Icon/IconSave';
import IconSelectAll from '../../../../../../Icon/IconSelectAll';
import IconSend from '../../../../../../Icon/IconSend';
import IconSort from '../../../../../../Icon/IconSort';
import IconTextFormat from '../../../../../../Icon/IconTextFormat';
import IconUnarchive from '../../../../../../Icon/IconUnarchive';
import IconUndo from '../../../../../../Icon/IconUndo';
import IconWeekend from '../../../../../../Icon/IconWeekend';

export default function ContentIcons() {
  return (
    <div>
      <CategoryHeader>content</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAdd size="32"/>
          <FigCaption>
            IconAdd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAddBox size="32"/>
          <FigCaption>
            IconAddBox
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAddCircle size="32"/>
          <FigCaption>
            IconAddCircle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAddCircleOutline size="32"/>
          <FigCaption>
            IconAddCircleOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconArchive size="32"/>
          <FigCaption>
            IconArchive
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBackspace size="32"/>
          <FigCaption>
            IconBackspace
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBlock size="32"/>
          <FigCaption>
            IconBlock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconClear size="32"/>
          <FigCaption>
            IconClear
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconContentCopy size="32"/>
          <FigCaption>
            IconContentCopy
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconContentCut size="32"/>
          <FigCaption>
            IconContentCut
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconContentPaste size="32"/>
          <FigCaption>
            IconContentPaste
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCreate size="32"/>
          <FigCaption>
            IconCreate
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDeleteSweep size="32"/>
          <FigCaption>
            IconDeleteSweep
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDrafts size="32"/>
          <FigCaption>
            IconDrafts
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFilterList size="32"/>
          <FigCaption>
            IconFilterList
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFlag size="32"/>
          <FigCaption>
            IconFlag
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFontDownload size="32"/>
          <FigCaption>
            IconFontDownload
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconForward size="32"/>
          <FigCaption>
            IconForward
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGesture size="32"/>
          <FigCaption>
            IconGesture
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInbox size="32"/>
          <FigCaption>
            IconInbox
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLink size="32"/>
          <FigCaption>
            IconLink
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLowPriority size="32"/>
          <FigCaption>
            IconLowPriority
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMail size="32"/>
          <FigCaption>
            IconMail
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMarkunread size="32"/>
          <FigCaption>
            IconMarkunread
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMoveToInbox size="32"/>
          <FigCaption>
            IconMoveToInbox
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNextWeek size="32"/>
          <FigCaption>
            IconNextWeek
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRedo size="32"/>
          <FigCaption>
            IconRedo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRemove size="32"/>
          <FigCaption>
            IconRemove
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRemoveCircle size="32"/>
          <FigCaption>
            IconRemoveCircle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRemoveCircleOutline size="32"/>
          <FigCaption>
            IconRemoveCircleOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReply size="32"/>
          <FigCaption>
            IconReply
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReplyAll size="32"/>
          <FigCaption>
            IconReplyAll
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconReport size="32"/>
          <FigCaption>
            IconReport
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSave size="32"/>
          <FigCaption>
            IconSave
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSelectAll size="32"/>
          <FigCaption>
            IconSelectAll
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSend size="32"/>
          <FigCaption>
            IconSend
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSort size="32"/>
          <FigCaption>
            IconSort
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTextFormat size="32"/>
          <FigCaption>
            IconTextFormat
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconUnarchive size="32"/>
          <FigCaption>
            IconUnarchive
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconUndo size="32"/>
          <FigCaption>
            IconUndo
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWeekend size="32"/>
          <FigCaption>
            IconWeekend
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/ContentIcons.js